import { render, staticRenderFns } from "./flowDetail.vue?vue&type=template&id=8ad7bb4e&scoped=true&lang=pug"
import script from "./flowDetail.vue?vue&type=script&lang=js"
export * from "./flowDetail.vue?vue&type=script&lang=js"
import style0 from "./flowDetail.vue?vue&type=style&index=0&id=8ad7bb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad7bb4e",
  null
  
)

export default component.exports